<template>
  <el-button
    v-if="showBtn"
    class="mr-1"
    title="Atsisiųsti ataskaitą"
    :loading="loading || btnLoading"
    color="secondary"
    icon="failas"
    @click.native.stop="downloadReport()"
  />
</template>

<script>
export default {
  name: 'ElReportBtn',
  props: {
    reportData: Object,
    loading: Boolean,
    object: String,
    filename: String,
    listURL: String
  },
  data() {
    return {
      btnLoading: false,
    }
  },
  computed: {
    showBtn() {
      // Object.keys(this.reportData).length > 1
      return true;
    },
  },
  methods: {
      downloadReport() {
      this.btnLoading = true
      const data = {
        search: this.reportData,
        isReport: true,
        object: this.object,
        listURL: this.listURL
      }

      let URL = '';
      if (this.listURL) {
        URL = `${this.object}/${this.listURL}`;
      } else {
        URL = `${this.object}/list`;
      }

      const dateNow = new Date();
      let filename = `report_${ dateNow.getFullYear() }_${ dateNow.getMonth() + 1 }_${ dateNow.getDate() }.xlsx`;
      if (this.filename) {
        filename = `${this.filename}_${ dateNow.getFullYear() }-${ dateNow.getMonth() + 1 }-${ dateNow.getDate() }_${ dateNow.getHours() + 1 }:${ dateNow.getSeconds() }.xlsx`;
      }

      this.$axios
      .post(URL, data, { responseType: 'arraybuffer' })
        .then((res) => {
          if (res.data.byteLength > 0) {
            var fileURL = window.URL.createObjectURL(new Blob([res.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.status && err.response.status === 422) {
            this.$root.$emit('DATA_ERROR_TEXT', 'Eksportuojamų įrašų limitas viršija 10000. Prašome susiaurinti paiešką.')
          }
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
  },
}
</script>
